import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import background from "../../assets/landing-background.jpg"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import MainIcon from "./Icon"

const useStyles = makeStyles(theme => ({
  header: {
    backgroundImage: `url(${background})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    width: "100%",
    textAlign: "left",
    padding: theme.spacing(1)
  },
  iconInHeader: {
    fontSize: "6rem",
    verticalAlign: "top",
    paddingRight: "10px",
    color: theme.palette.primary.main
  }
}))

const SectionHeader = ({title, body, iconRef=null}) => {
  const classes = useStyles()

  return (
    <div>
      <Paper elevation={0} className={classes.header}>
        {iconRef &&
          <MainIcon iconRef={iconRef} classStyle={classes.iconInHeader}/>
        }
        <Typography color="primary" variant="h1" display={"inline"} gutterBottom>
          {title}
        </Typography>
        {body && body.map((para, index) => (
          <Typography key={`${title}_${index}`} variant="h5" gutterBottom>
            {para}
          </Typography>
        ))}
      </Paper>
    </div>
  )
}

export default SectionHeader
